import { createClient } from '@supabase/supabase-js'

// Supabase configuration - optimized for Netlify deployment
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://qjvjrhlfceingajwpvoy.supabase.co'
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFqdmpyaGxmY2Vpbmdhandwdm95Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI1NjA1OTYsImV4cCI6MjA2ODEzNjU5Nn0.S2B1hwulvAcgrdCVv3aiOT0YU3td8w_YTkCtyuh2PFE'

// Validate environment variables
if (!supabaseUrl || !supabaseKey) {
  console.error('Missing Supabase environment variables')
  throw new Error('Supabase configuration is incomplete')
}

// Create Supabase client with enhanced configuration for production
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    // Enhanced auth settings for production
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    // Set storage for better persistence in production
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
  // Enhanced database settings
  db: {
    schema: 'public',
  },
  // Global settings for better reliability
  global: {
    headers: {
      'X-Client-Info': 'plugin-download-platform@1.0.0',
    },
  },
  // Realtime disabled for now (can be enabled later if needed)
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
})

// Helper function to handle Supabase errors consistently
export const handleSupabaseError = (error: any): string => {
  console.error('Supabase error:', error)
  
  // Handle common error types
  if (error?.code === 'PGRST116') {
    return 'Resource not found'
  }
  
  if (error?.code === '23505') {
    return 'This value already exists'
  }
  
  if (error?.code === '42501') {
    return 'You do not have permission to perform this action'
  }
  
  if (error?.code === '42P17') {
    return 'Database policy error - please try again'
  }
  
  if (error?.message) {
    return error.message
  }
  
  return 'An unexpected error occurred'
}

// Health check function for deployment verification
export const checkSupabaseConnection = async (): Promise<boolean> => {
  try {
    const { data, error } = await supabase.from('profiles').select('count').limit(1)
    return !error
  } catch (err) {
    console.error('Supabase connection check failed:', err)
    return false
  }
}

// Export configuration for debugging (non-sensitive info only)
export const supabaseConfig = {
  url: supabaseUrl,
  hasKey: !!supabaseKey,
  environment: import.meta.env.MODE || 'development',
} 